export const createFilterProps = ({
  handleFeeTypeChange
}) => ({
  onFeeTypeChange: handleFeeTypeChange
});